module.exports = __webpack_public_path__ + "img/contactus.2c207834.jpg";